import React, { useEffect } from 'react';

import Login from '@pages/Login';
import { FCWithChildren } from '@types';

const ResetPassword: FCWithChildren<{}> = () => {
  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    if (token) {
      sessionStorage.setItem('resetToken', token);
      url.searchParams.delete('token');
      window.location.href = url.pathname + url.search;
    }
  }, []);
  return <Login initialState="RESET_PASSWORD" />;
};

export default ResetPassword;
